module.exports = __webpack_public_path__ + "static/media/triple-standard-img4.35ee1da5.jpg";